// /staff/print — the one printable sheet.
//
// It used to print two things: an event QR pointing at guest registration, and
// a card per guest with a QR to their private gallery. Both are gone with
// registration itself — there is no per-guest anything to print, and nothing
// for a guest to sign up for.
//
// What survives is a QR to the WALL, for signage next to the screen: someone
// standing across the room, or waiting for their turn, can watch the same feed
// on their own phone. It shows exactly what the projector shows — approved
// photos and nothing else — so it needs no gate of its own.
//
// Print styles are inline-critical: this page is opened, printed, and closed,
// often on venue wifi, so it must not depend on anything loading.
import { useEffect, useState } from "react";
import QRCode from "qrcode";

export default function Print() {
  const [wallQr, setWallQr] = useState<string | null>(null);
  const origin = globalThis.location?.origin ?? "";

  useEffect(() => {
    QRCode.toDataURL(`${origin}/wall`, {
      width: 1024,
      margin: 1,
      color: { dark: "#000000", light: "#ffffff" },
    }).then(setWallQr).catch(() => setWallQr(null));
  }, [origin]);

  return (
    <div dir="ltr" className="print-root">
      {/* Printing is the entire purpose of the page: force a white, ink-cheap
          sheet regardless of the dark app theme, and hide the controls. */}
      <style>
        {`
        .print-root { background:#fff; color:#000; min-height:100dvh; padding:24px; }
        .card { break-inside: avoid; page-break-inside: avoid; }
        @media print {
          .no-print { display:none !important; }
          .print-root { padding:0; }
          @page { margin: 12mm; }
        }
      `}
      </style>

      <div className="no-print mb-6 flex flex-wrap items-center gap-3">
        <button
          type="button"
          onClick={() => globalThis.print()}
          className="rounded-lg bg-black px-4 py-2 text-sm font-semibold text-white"
        >
          Print
        </button>
        <span className="text-sm text-neutral-600">
          One sheet: the QR for the public screen.
        </span>
      </div>

      <section className="card text-center">
        <h1 className="text-3xl font-bold tracking-tight">LAQTA · لقطة</h1>
        <p className="mt-1 text-sm text-neutral-600">LYNK &amp; CO</p>
        {wallQr && <img src={wallQr} alt="" className="mx-auto mt-4 size-64" />}
        <p dir="rtl" lang="ar" className="mt-3 text-lg font-semibold">
          امسح الرمز لمشاهدة الشاشة على هاتفك
        </p>
        <p className="text-sm text-neutral-600">
          Scan to watch the screen on your phone
        </p>
      </section>
    </div>
  );
}
